// imports
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// components
import SandCoatingSelect from 'components/common/simpleSelectors/SandCoating';
// interfaces
import { SandCoatingSelectorProps } from 'interfaces';

const SandCoatingSelector: FC<SandCoatingSelectorProps> = ({ name, title, handleChange, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { name, onBlur, onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        return (
          <SandCoatingSelect
            name={name}
            title={title}
            value={value}
            onBlur={onBlur}
            helperText={message}
            error={Boolean(message)}
            handleChange={(val) => {
              onChange(val);
              handleChange && handleChange(val);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

export default SandCoatingSelector;
